import { Component, ViewChild, OnInit } from '@angular/core';
import { ProductdetailsData } from "../providers/productdetails";
import { ProductDetailsType } from "../providers/productdetailstype";
import { ProductDetailsService } from "../providers/productdetails.service";
import { DatePipe } from '@angular/common';
import { Router, NavigationStart } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { CustomStorage } from '../providers/Custom-storage.service';
import { RestApiServices } from '../providers/rest.service';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';
import { SharedServiceService } from '../shared/shared-service.service';
import { LanguageService } from '../providers/lang.service';
import { NgForm } from '@angular/forms';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CartitemsService } from '../providers/cartitems.service';
import { environment } from '../../environments/environment';
import { Toast, ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { BrowserModule } from '@angular/platform-browser';
import { Directive, ElementRef } from '@angular/core';
@Component({
  selector: 'cartdetails',
  templateUrl: './cartdescription.component.html',
  styleUrls: ['./cartdescription.component.css']
})
export class CartdescriptionComponent implements OnInit {
  @ViewChild('f') signupForm: NgForm;
  companyControl = new FormControl('', [Validators.required]);
  selectedInstock: number;

  item = {
    color: '',
    size: ''
  };

  noPdfavl = false;
  productDetails: any = {};cartItems: any = [];
  prodID: number;
  private imageUrl = environment.imageUrl;
  showloading: boolean = true;quantityincart:string = "";orderincart:string = "";
  private subscription: Subscription = new Subscription();commitincart:string = "";
  stock: string = ""; item_number: string = ""; product_details: string = ""; unit_price: string = "";
  product_info: string = ""; features: string = ""; addto_cart: string = "";
  selectedColor: any = 0; in_stock: string = ""; quantity_cart: string = ""; unit_color: string; unit_size: string;
  selectedSize: any = 0; selcet_color: string = ""; selcet_size: string = ""; quantity_txt: string = "";
  selectedquantity: any = 0; yes: string = ""; no: string = ""; cartMsg1: string = "";
  Lbl_check_quantity: string = ""; cartMsg2: string = ""; cartMsg3: string = ""; pdfnot_avail: string = "";
  submitted = false; left_instock: string = ""; lbl_uom: string = ""; lbl_qty: string = "";blank_qty: string = "";
  match = true;txt_pdfview: string = "";txt_click: string = "";txt_validqty: string = "";
  error_message: string;txt_onorder: string = "";txt_commitqty
  quantityhand: string = "";
  quantityValue: number;
  hideColorSpinner: boolean = false;
  unique_array = [];
  showDialog: boolean = false;
  colorSelected: boolean = false;
  sizeSelected: boolean = false;
  showErrorMsg = false;
  hideSizeSpinner: boolean = false;
  errorquantitymsg: boolean = false;  
  private toasterService: ToasterService;
  classMap = { 'form-group': true, "haserror": false };
  public config: ToasterConfig = new ToasterConfig({
    positionClass: 'toast-top-right'

  });

  constructor(private localCart: CartitemsService, private restApi: RestApiServices, private langService: LanguageService,
    route: ActivatedRoute, private localstorage: CustomStorage, public router: Router, public el: ElementRef,
    private location: Location, private sharedService: SharedServiceService, toasterService: ToasterService) {
    this.prodID = route.snapshot.params['productid'];
    this.toasterService = toasterService;

    this.el.nativeElement.onkeypress = (event) => {
      if (event.which >= 48 && event.which <= 57) {
        // to allow numbers  
        return true;
        //  } else if (event.which >= 96 && event.which <= 105) {  
        //      // to allow numpad number  
        //      return true;  
      } else if ([8, 0, 127, 46].indexOf(event.which) > -1) {
        // to allow backspace, enter, escape, arrows  
        return true;
      }
      else {
        event.preventDefault();
        // to stop others  
        return false;
      }

    };

  }
  ngOnInit() {
    this.langService.getJson().subscribe(data => {
      this.setLabels();

      this.localstorage.getItem('productSelected').subscribe(data => {
        if (data != null && data != undefined) {
          for (let indx = 0; indx < data.product_info.more_product_data.length; indx++) {
            // if(data.product_info.more_product_data[indx].color==""){
            //   data.product_info.more_product_data[indx].color="No Color Description.";  
            // }
            if (this.unique_array.indexOf(data.product_info.more_product_data[indx].color) == -1) {
              this.unique_array.push(data.product_info.more_product_data[indx].color);

            }
          }
          this.productDetails = data;
          this.hidespinner();
          this.hidesizespinner();
          if (this.productDetails.product_info.more_product_data.length <= 0) {
            this.instock.push(this.productDetails.qty_on_hand);
            this.unitprice.push(this.productDetails.price);
          }
          this.validateSubmit();
        }
      });
      this.localCart.loadCartItems();
      this.localCart.cartList.subscribe(res => {
        this.cartItems = res;
      });
    });
  }

  close() {
    this.location.back();
  }

  setLabels() {
    this.langService.getLangLabelValue("LblInStock").then(result => {
      this.stock = result;
    });

    this.langService.getLangLabelValue("LblItem").then(result => {
      this.item_number = result;
    });
    this.langService.getLangLabelValue("LblProductDetails").then(result => {
      this.product_details = result;
    });
    this.langService.getLangLabelValue("LblProductInformation").then(result => {
      this.product_info = result;
    });
    this.langService.getLangLabelValue("LblFeatures").then(result => {
      this.features = result;
    });
    this.langService.getLangLabelValue("LblAddToCart").then(result => {
      this.addto_cart = result;
    });
    this.langService.getLangLabelValue("LblUnitPrice").then(result => {
      this.unit_price = result;
    });
    this.langService.getLangLabelValue("LblInStock").then(result => {
      this.in_stock = result;
    });
    this.langService.getLangLabelValue("LblQuantityInCart").then(result => {
      this.quantity_cart = result;
    });
    this.langService.getLangLabelValue("LblColor").then(result => {
      this.unit_color = result;
    });
    this.langService.getLangLabelValue("LblSize").then(result => {
      this.unit_size = result;
    });
    this.langService.getLangLabelValue("LblSelectColor").then(result => {
      this.selcet_color = result;
    });
    this.langService.getLangLabelValue("LblselectSize").then(result => {
      this.selcet_size = result;
    });
    this.langService.getLangLabelValue("LblenterQuantityHere").then(result => {
      this.quantity_txt = result;
    });
    this.langService.getLangLabelValue("LblYes").then(result => {
      this.yes = result;
    });
    this.langService.getLangLabelValue("LblNo").then(result => {
      this.no = result;
    });
    this.langService.getLangLabelValue("200_not_enough_qty_cart1").then(result => {
      this.cartMsg1 = result;
    });
    this.langService.getLangLabelValue("200_not_enough_qty_cart2").then(result => {
      this.cartMsg2 = result;
    });
    this.langService.getLangLabelValue("200_not_enough_qty_cart3").then(result => {
      this.cartMsg3 = result;
    });
    this.langService.getLangLabelValue("LblCheckQuantity").then(result => {
      this.Lbl_check_quantity = result;

    });
    this.langService.getLangLabelValue("LblPDFNotAvailable").then(result => {
      this.pdfnot_avail = result;

    });
    this.langService.getLangLabelValue("LblLeftInStock").then(result => {
      this.left_instock = result;

    });
    this.langService.getLangLabelValue("LblItemUOM").then(result => {
      this.lbl_uom = result;
    });
    this.langService.getLangLabelValue("LblUOMQty").then(result => {
      this.lbl_qty = result;
    });
    this.langService.getLangLabelValue("LblQuantityCantBeBlank").then(result => {
      this.blank_qty = result;  
    });
    this.langService.getLangLabelValue("LblViewPDF").then(result => {
      this.txt_pdfview = result;  
    });
    this.langService.getLangLabelValue("LblClickHere").then(result => {
      this.txt_click = result;  
    });
    this.langService.getLangLabelValue("200_enter_valid_quantity").then(result => {
      this.txt_validqty = result;  
    });
    this.langService.getLangLabelValue("LblOnOrder").then(result => {
      this.txt_onorder = result;  
    });
    this.langService.getLangLabelValue("LblCommitQty").then(result => {
      this.txt_commitqty = result;  
    });
  }

  onSubmit() {

    this.submitted = true;
    this.item.color = this.signupForm.value.userData.color;
    this.item.size = this.signupForm.value.userData.size;
    if (this.item.color == '' || this.item.size != '') {
      this.error_message = "color is blank";
    }
    else if (this.item.color != '' || this.item.size == '') {
      this.error_message = "color is blank";
    }
    else if (this.item.color == '' || this.item.size == '') {
    }

    else {
      this.match = false;
    }
  }

  unitprice = [];
  instock = [];
  sizeData = [];
  colorChanged(selectedColor) {
    this.sizeData = [];
    this.instock = [];
    this.colorSelected = false;
    for (let item of this.productDetails.product_info.more_product_data) {
      if (selectedColor == item.color) {
        this.sizeData.push(item.size);
        this.instock.push(item.in_stock);
        this.unitprice.push(item.unit_price);
        this.colorSelected = true
        this.sizeSelected = true
      }
    }
    if (this.sizeData.length > 0) {
      this.selectedSize = this.sizeData[0];
    }

    this.validateSubmit()

  }
  sizeChanged(selectedSize) {
    this.sizeData = [];
    this.instock = [];
    this.sizeSelected = false;

    for (let item of this.productDetails.product_info.more_product_data) {
      if (selectedSize == item.size) {
        // this.sizeData.push(item.size);
        this.instock.push(item.in_stock);
        this.unitprice.push(item.unit_price);
        this.sizeSelected = true;
      }
    }
    if (this.sizeData.length > 0) {
      this.selectedSize = this.sizeData[0];
    }
    this.validateSubmit()
  }
  currentProduct: any;
  addItemInCart(product) {
    this.colorSelected = this.selectedColor != 0;
    this.sizeSelected = this.selectedSize != 0;
    this.currentProduct = product;
    this.validateSubmit()
    if(!this.quantityValue){
      this.errorquantitymsg = true
     return true;
    }
    if (this.quantityValue > this.getSelectedItemStock()) {
      this.showDialog = !this.showDialog;
      return true;
    }
    if (this.hidespinner() || this.hidesizespinner()) {
      if (this.showErrorMsg) {
        return false
      }
      this.proceed();
      return true

    }
    else if (!this.colorSelected || !this.sizeSelected) {
      return false;
    }

    // if(this.quantityValue > this.getSelectedItemStock()){
    //   this.showDialog = !this.showDialog;
    // }else{
    this.proceed();
    // }

  }
  proceed() {
    let product = this.currentProduct;
    let selectedCartItem = Object.assign({}, product);
    this.submitted = true;
    let colorValue = this.signupForm.value.userData.color;
    let sizeValue = this.signupForm.value.userData.size;
    let quantityValue = this.signupForm.value.userData.quantity;
    // delete selectedCartItem.more_product_data;
    let unique_id_t = product.item_number
    if (colorValue) {
      selectedCartItem.item_color = colorValue.color;
      unique_id_t += colorValue.color
    }
    if (sizeValue) {
      selectedCartItem.item_size = sizeValue.size;
      unique_id_t += sizeValue.size
    }

    selectedCartItem.unit_price = product.price;
    // selectedCartItem.temp_id = product.item_number + colorValue.color + sizeValue.size;
    selectedCartItem.unique_id = unique_id_t;
    selectedCartItem.quantity = Number.parseFloat(quantityValue.quantity);
    this.localCart.addItemtoCart(selectedCartItem);
    this.popToast();
    this.router.navigate(['/dashboard/shop/topsales']);
  }

  popToast() {
    var toast: Toast = {
      type: 'info',
      title: 'description',
      body: 'item added successfully',
      timeout: 0
    };

    this.toasterService.pop(toast);
  }

  validQuantity() {
    //if(this.selectedColor === undefined || this.selectedSize === undefined || this.quantityValue === undefined){
    if (this.quantityValue == undefined) {
      //if color and size is not selected then we are not validaing stock
      return true;
    }
    this.validateSubmit()
    let instock = this.getSelectedItemStock();
    if (instock > 0 && this.quantityValue > instock) {
      return false;
    }
    // this.someProperty = !this.someProperty
    return true;

  }

  getSelectedItemStock() {
    // console.log(this.productDetails.more_product_data.length)   
    if (this.productDetails.product_info.more_product_data.length <= 0) {
      return this.productDetails.qty_on_hand;
    }
    for (let item of this.productDetails.product_info.more_product_data) {
      // if(this.selectedColor ==  "Not Applicable"){
      //   this.selectedInstock = item["in_stock"];
      //   return item["in_stock"];
      // }
      // if( this.selectedSize ==  "Not Applicable"){
      //   this.selectedInstock = item["in_stock"];
      //   return item["in_stock"];
      // }
      if (this.selectedColor == item.color && this.selectedSize == item.size) {

        this.selectedInstock = item["in_stock"];
        return item["in_stock"];
      }
      if (this.selectedSize == item.size) {
        this.selectedInstock = item["in_stock"];
        return item["in_stock"];
      }
      // if (this.quantityValue) {
      //   return this.productDetails.qty_on_hand;
      // }
    }
  }


  canSubmit() {
    if (this.productDetails.product_info.more_product_data.length <= 0) {
      return this.quantityValue > 0;
    }
    return this.quantityValue > 0;
    // return this.selectedColor != 0 && this.selectedSize != 0 && this.quantityValue > 0;
  }
  noPdf() {
    this.noPdfavl = true;
    setTimeout(function () {
      this.noPdfavl = false;
    }.bind(this), 7000);
  }

  hidespinner() {
    for (let indx = 0; indx < this.productDetails.product_info.more_product_data.length; indx++) {
      if (this.productDetails.product_info.more_product_data[indx].color == "Not Applicable") {
        this.hideColorSpinner = true;
        this.selectedColor = "Not Applicable"
        return true
      }
    }
    return false
  }
  hidesizespinner() {
    for (let indx = 0; indx < this.productDetails.product_info.more_product_data.length; indx++) {
      if (this.productDetails.product_info.more_product_data[indx].size == "Not Applicable") {
        this.hideSizeSpinner = true;
        this.selectedSize = "Not Applicable"
        return true
      }
    }
    return false
  }

  validateSubmit() {
    let valid = true
    valid = valid && (this.hideColorSpinner || this.colorSelected)
    valid = valid && (this.hideSizeSpinner || this.sizeSelected)
    // valid =  this.getSelectedItemStock() >= this.quantityValue 
    this.showErrorMsg = this.quantityValue != undefined && !valid

  }

  getErrorMsg() {
    if (!this.hideColorSpinner && !this.hideSizeSpinner) {
      if (!this.colorSelected && !this.sizeSelected) {
        return "Please Select color and Size"
      }
      if (!this.colorSelected) {
        return "Please Select Color"
      }
      if (!this.sizeSelected) {
        return "Please Select Size"
      }
    }

    if (!this.hideColorSpinner) {

      if (!this.colorSelected) {
        return "Please Select Color"
      }

    }

    if (!this.hideSizeSpinner) {

      if (!this.sizeSelected) {
        return "Please Select Size"
      }
    }
  }
  getQuantityinCart(item) {
    if (item.size == this.productDetails.item_size) {
      this.quantityincart = this.productDetails.quantity;
      return this.quantityincart;
    }
    return "";
  }
  getonorderinCart(item) {
    if (item.size == this.productDetails.item_size) {
      this.orderincart = this.productDetails.product_info.on_order;
      console.log("oderoncart"+ this.orderincart);
      return this.orderincart;
    }
    return "";
  }
  getoncommitinCart(item) {
    if (item.size == this.productDetails.item_size) {
      this.commitincart = this.productDetails.product_info.commit_qty;
      return this.commitincart;
    }
    return "";
  }
}


// WEBPACK FOOTER //
// ./src/app/cartdescription/cartdescription.component.ts